<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop" style="text-align: center;">For Don and Robin</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_dedication.vue?a713d09c